import type { Messages } from '../messages.js'

/**
 * Afrikaans. `skuiwe` for flips, the way Dutch takes `zetten`: a move you pay for, which is
 * what the meter counts, rather than the physical turning of a tile.
 *
 * `blokkies` for tiles, which is what an Afrikaans board game calls them.
 */
export const af: Messages = {
  tag: 'af',

  readingDictionary: 'Woordeboek word gelees…',
  noWordList: 'Geen woordelys vir "{language}" nie. Bou een:  pnpm dictionary build',
  emptyWordList: 'Die woordelys vir "{language}" is leeg.',

  flips: 'skuiwe',
  score: 'punte',
  words: 'woorde',
  round: 'rondte',
  ticksLeftLabel: 'Tyd oor in hierdie rondte',
  typeAWord: 'tik ’n woord',
  tapPrompt: 'tik letters om te kies of terug te gee, dan {action}',

  boardOfTiles: 'Bord van {n} blokkies',
  faceDown: 'omgedraai',
  wildCard: 'joker',
  wildKey: 'enige letter',
  letterReplaced: '{from} het {to} geword',
  letterSwap: 'LETTER RUIL!',
  spentTile: 'gebruikte blokkie',
  hiddenWhilePaused: 'weggesteek terwyl gepouseer',
  letterInWord: '{letter}, letter {position} van die woord',

  completeWord: 'Voltooi woord',

  completeShort: 'Voltooi',
  reset: 'Herstel',
  pause: 'Pouse',
  resume: 'Gaan voort',
  newGame: 'Nuwe spel',
  paused: 'Gepouseer',
  outOfFlips: 'Skuiwe op',
  finalResult: '{score} punte uit {words} oor {rounds}',
  playAgain: 'Speel weer',
  share: 'Deel',
  shareCopied: 'Gekopieer.',
  shareSelect: 'Kopieer dit:',

  lettersSelect: 'letters kies',
  keysWild: 'word geneem wanneer jy ’n letter tik wat geen blokkie wys nie',
  clearsEvery: 'wis al die gekose {letter}’s',
  undoLastLetter: 'laaste letter terug',
  noWordsYet: 'Nog geen woorde nie.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'reeds gevind',
  reasonTooShort: 'te kort',
  reasonNotAWord: 'nie ’n woord nie',
  reasonAllFound: 'jy het hulle almal al',
  noSuchLetterUp: 'geen {letter} oop nie',
  nothingUp: 'nie oop nie',
  letterHidden: '’n letter het weggekruip',
  shuffled: 'geskommel',
  shuffledAndBilled: 'geskommel, {flips} ongebruikte skuiwe gehef',
  tooFewLetters: 'Te min letters oor',

  gameLanguage: 'taal',
  interfaceLanguage: 'koppelvlak',
  dictionarySize: '{common} algemene van {full} woorde',
  filterLanguages: 'Soek tale',
  noMatches: 'Geen resultate',

  nerdMode: 'nerd-modus',
  rules: 'Reëls',
  difficulty: 'moeilikheid',
  difficultyNames: { easy: 'maklik', medium: 'middel', hard: 'moeilik', insane: 'waansinnig' },
  pausedNoBoard: 'Hierdie spel kom nie op die ranglys nie.',
  about: 'Oor',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradisioneel', light: 'daglig', contrast: 'hoë kontras' },
  tiles: 'blokkies (N)',
  secondsPerTick: 'sekondes / tik',
  holdTicks: 'houtikke',
  minWord: 'kortste woord',
  startingFlips: 'beginskuiwe',
  wildChance: 'kans op joker',
  replaceChance: 'kans op letterruil',
  hideChance: 'kans op letterversteek',
  wordCompleteMode: 'woord voltooi',
  wordCompleteNames: { shuffle: 'skommel', spend: 'gebruik', keep: 'hou' },
  flipEconomy: 'skuifekonomie',
  flipEconomyNames: {
    none: 'geen',
    perLetter: 'per letter',
    fibonacci: 'fibonacci',
    overMinimum: 'bo die minimum',
  },
  repeatedLetterKey: 'herhaalde letter-sleutel',
  keySchemeNames: { cycle: 'siklus', advance: 'vorentoe' },
  keySchemeHelp: {
    cycle:
      'A neem die volgende ongebruikte A, en sodra hulle almal in die woord is, wis dit hulle. ' +
      'Shift+A wis hulle ook.',
    advance: 'A neem die volgende ongebruikte A. Shift+A wis elke A in die woord.',
  },

  whatThatMeans: 'Wat dit beteken',
  factRound: 'rondte',
  factWholeBoardUp: 'hele bord oop vir',
  factRoundCosts: '’n rondte kos',
  factFlipsBuy: 'beginskuiwe koop',
  factThisBoard: 'hierdie bord',
  factBoardHadToAdmit: 'bord moes toelaat',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, langste {longest}',
  wordsIncludingOneOf: '{words} ins. een van {ceiling}',
  scorelessRounds: '{rounds} sonder punte',

  whatAWordPays: 'Wat ’n woord betaal',
  columnLetters: 'letters',
  columnCost: 'koste',
  columnPoints: 'punte',
  columnFlips: 'skuiwe',
  columnNet: 'netto',

  canonicalRules: 'Standaardreëls vir {difficulty}.',
  customRules: 'Van die voorinstelling verander. Punte onder eie reëls word nie gerangskik nie.',
  applyAndStart: 'Pas toe en begin ’n nuwe spel',
  changesNextGame: 'Veranderinge geld vanaf die volgende spel.',
  presets: 'Voorinstellings:',

  start: 'Begin',
  restart: 'Herbegin',
  quit: 'Stop',
  quitTitle: 'Hierdie spel stop?',
  restartTitle: 'Hierdie spel herbegin?',
  restartConfirm: 'Herbegin',
  quitConfirm: 'Stop',
  keepPlaying: 'Speel verder',
  personalBest: 'Jou beste spele',
  newPersonalBest: '’n Nuwe persoonlike beste.',
  columnRank: '#',
  notRanked: 'Eie reëls, so hierdie spel word nie gerangskik nie.',
  notRankedPaused: 'Die klok het gestop, so hierdie spel word nie gerangskik nie.',
  rankOfTotal: '{rank} van {total}',

  howToPlay: 'Hoe om te speel',

  backToGame: 'Terug na die spel',
  welcomeTitle: 'Welkom by Blinkered',
  tutorialSkip: 'Slaan oor',
  tutorialNext: 'Volgende',
  tutorialBack: 'Terug',
  tutorialStart: 'Begin speel',
  tutorialHideAgain: 'Moenie dit weer wys nie',
  tutorialProgress: '{n} van {total}',
  tutorialSkipTitle: 'Die rondleiding oorslaan?',
  tutGoalTitle: 'Blinkered is ’n wedloop',
  tutGoalBody:
    'Jy begin die spel met ’n vaste aantal skuiwe, en elke blokkie wat draai kos een skuif. Wanneer die skuiwe op is, is die spel verby. Woorde verdien skuiwe, en hoe langer die woord, hoe meer skuiwe verdien jy.',
  tutSpentBody:
    'Letters wat jy in ’n woord gebruik, word omgedraai en bly so tot die volgende rondte. Net ’n lettervervanging verander watter letters op die bord is.',
  tutChangeTitle: 'Letters kan verander',
  tutSameLetters:
    'Het jy ’n woord raakgesien wat jy nie betyds kon speel nie? Dieselfde letters kom volgende rondte terug, geskommel na nuwe plekke.',
  tutPickLetters: 'Tik die letters wat jy wil hê, in volgorde, om ’n woord te vorm.',
  tutMoreTurn: 'Blokkies draai aan terwyl jy dink, so ’n beter letter kan nog kom.',
  tutTapBack:
    'Een getik wat jy nie wou hê nie? Tik dit weer om dit terug te gee. Enigeen, nie net die ' +
    'laaste een nie.',
  tutComplete: 'Druk Voltooi wanneer die woord gereed is.',
  htBoardTitle: 'Die bord',
  htBoardBody:
    'Blokkies draai een vir een oop, in willekeurige volgorde. Met die oop blokkies vorm jy woorde.',
  htWordsTitle: 'Die woorde',
  htWordsBody: 'Vorm ’n woord uit die oop blokkies deur die letters in volgorde te tik of te klik.',
  htFlipsTitle: 'Die skuiwe',
  htFlipsBody:
    'Elke blokkie wat draai kos een skuif. ’n Voltooide woord gee skuiwe terug op jou telling, en lang woorde gee meer. Wanneer die skuiwe op is, is die spel verby.',
  htRoundTitle: 'Die rondte',
  htRoundBody:
    'Wanneer die laaste blokkie van ’n rondte draai, bly die hele bord ’n oomblik lank oop. Dan word die blokkies omgedraai en geskommel, en ’n nuwe rondte begin.',
  htLanguagesTitle: 'Die tale',
  htLanguagesBody:
    '{n}. Elke bord is oplosbaar met woorde wat mense werklik gebruik. ’n Ongewone woord tel ook, as die woordeboek dit ken.',
  htKeysTitle: 'Die sleutelbord',
  htWildTitle: 'Jokers',
  htWildBody:
    'Soms verskyn ’n joker in plaas van ’n letter. ’n Joker geld as enige letter wat ’n geldige woord maak. ’n Woord wat jy reeds voltooi het, tel nie.',
  htHideTitle: 'Letters wat wegkruip',
  htHideBody:
    'Op die moeiliker vlakke kan ’n oop letter self weer omdraai en later in die rondte terugkom. Die tydbalk kry ’n ekstra tik daarvoor, in rooi. Reeds gekose letters draai nie om nie.',
  tutHideBody:
    'Op die moeiliker vlakke kan ’n oop letter self weer omdraai en later in die rondte terugkom. Reeds gekose letters draai nie om nie.',
  htSwapTitle: 'Letters wat verander',
  htSwapBody:
    'Soms word tussen die rondtes een letter deur ’n ander vervang. Jy sien watter letter weg is en watter bygekom het.',
  htLevelsTitle: 'Die vlakke',
  htLevelEasy:
    'Dieselfde twaalf letters die hele spel lank, sodat jy hulle kan leer en ’n lys woorde in jou kop kan hou. Blokkies draai stadig, en die vol bord bly lank genoeg sigbaar om rustig klaar te kies.',
  htLevelMedium:
    'Nou en dan verander ’n letter, en dan is dit moeiliker om woorde te onthou wat jy later wou speel. Minder tyd om te kyk en minder om te dink.',
  htLevelHard:
    'Woorde van drie letters tel nie meer nie, en omtrent elke tweede rondte verander ’n letter. Die bord is skaars oop of dit skommel weer.',
  htLevelInsane:
    'Alles gelyktydig, teen volle spoed. Die bord skommel byna dadelik ná die laaste skuif.',
  htTouchTitle: 'Die raakskerm',
  htTouchBody:
    'Tik ’n oop blokkie om sy letter te neem. Tik enige letter wat jy geneem het om dit terug te gee. Voltooi en Herstel sit onder die bord.',

  accountTitle: 'Jou rekening',
  menuProfile: 'My profiel',
  menuGames: 'My speletjies',
  menuPublicPage: 'My openbare bladsy',
  menuSignedInAs: 'Aangemeld as',
  signIn: 'Meld aan',
  signOut: 'Meld af',
  signInTitle: 'Meld aan of registreer',
  signInLead: '’n Rekening hou jou speletjies, op elke toestel.',
  signInKeepGame: 'Meld aan om hierdie speletjie te hou, en almal daarna.',
  continueWithApple: 'Gaan voort met Apple',
  continueWithGoogle: 'Gaan voort met Google',
  signInOr: 'of',
  emailLabel: 'E-pos',
  codeLabel: 'Kode',
  emailMeACode: 'Stuur my ’n kode',
  working: 'Net ’n oomblik…',
  sendNewCode: 'Stuur ’n nuwe kode',
  codeSent: 'Kyk in jou e-pos. Die kode hou 10 minute.',
  notNow: 'Nie nou nie',
  badEmail: 'Dit lyk nie na ’n e-posadres nie.',
  badCode: 'Daardie kode het nie gewerk nie. Kodes verval na 10 minute en werk een keer.',
  serverBusy: 'Kon nie die bediener bereik nie. Probeer weer oor ’n oomblik.',
  serverDown: 'Kon nie die bediener bereik nie.',
  offline: 'Aflyn',
  leaderboardTitle: 'Ranglys',
  leaderboardEmpty: 'Nog geen speletjies op hierdie bord nie. Wees die eerste.',
  leaderboardWouldBe: 'Waar hierdie speletjie sou staan',
  leaderboardThisGame: 'Hierdie speletjie',
  leaderboardRanksHere: 'Waar hierdie speletjie staan',
  leaderboardOutside: 'Buite die beste vyf.',
  tutAccountTitle: 'Hou jou tellings',
  tutAccountBody:
    '’n Rekening stoor jou speletjies, plaas jou tellings op die ranglys, en hou jou profiel.',
  ssoCancelled: 'Aanmelding gekanselleer.',
  ssoExpired: 'Dit het te lank geneem. Meld weer aan.',
  ssoNoUsername: 'Kon nie die rekening klaar skep nie. Probeer weer oor ’n oomblik.',
  ssoFailed: 'Dit het nie gewerk nie. Probeer weer, of gebruik jou e-pos.',
  tabProfile: 'Profiel',
  countryAny: 'Sê liewer nie',
  findCountry: 'Soek lande',
  usernameLabel: 'Gebruikersnaam',
  bioLabel: 'Oor my',
  countryLabel: 'Land',
  bioHint: 'Geen skakels nie. {left}/{max}',
  save: 'Stoor',
  saving: 'Stoor tans…',
  saved: 'Gestoor.',
  nameTaken: 'Iemand het al daardie naam.',
  nameTooShort: '’n Bietjie langer, asseblief.',
  nameTooLong: 'Dis te lank.',
  nameBadCharacters: 'Net letters, syfers, koppeltekens en onderstrepe.',
  nameBadEdges: 'Dit moet met ’n letter of syfer begin en eindig.',
  nameMixedScripts: 'Kies een alfabet en bly daarby.',
  nameReserved: 'Dit lyk na ’n naam wat ons self uitdeel. Kies ’n ander een.',
  nameUnusable: 'Daardie naam kan nie gebruik word nie.',
  bioTooLong: 'Hier pas hoogstens {max} karakters.',
  bioHasLink: 'Skakels word nie hier toegelaat nie.',
  bioHasControl: 'Dit bevat karakters wat nie hier kan wees nie.',
  bioUnusable: 'Daardie teks kan nie gebruik word nie.',
  gamesHeading: 'Speletjies',
  gamesEmpty: 'Nog niks hier nie. Speletjies wat jy aangemeld speel, verskyn hier.',
  gamesEmptyShort: 'Nog niks hier nie.',
  gamesLoading: 'Lees jou speletjies…',
  theirGamesLoading: 'Lees hulle speletjies…',
  profileLoading: 'Lees die profiel…',
  playerNotFound: 'Daar is niemand hier met daardie naam nie.',
  columnWhen: 'Wanneer',
  columnRounds: 'rondtes',
  columnGame: 'Speletjie',
  gameLoading: 'Lees die speletjie…',
  gameUnreadable: 'Hierdie speletjie kon nie gelees word nie.',
  gameNotRanked: 'Met veranderde reëls gespeel, so dit tel nie.',
  detailNotKept: 'Die woorde en borde van hierdie speletjie word nie meer gehou nie.',
  openingBoard: 'Die openingsbord',
  roundByRound: 'Rondte vir rondte',
  roundNothing: 'niks gevind nie',
  changeReplaced: '{letter} vervang in plek {slot}',
  changeWildOn: '{letter} joker in plek {slot}',
  changeWildOff: '{letter} joker weg uit plek {slot}',
  keepThisGame: 'Hou hierdie speletjie',
  savedToYourGames: 'Gestoor by jou speletjies.',

  reportThis: 'Rapporteer',
  reportHeading: 'Rapporteer dit',
  reportTheName: 'Die naam',
  reportTheBio: 'Die beskrywing',
  reportTheScore: 'Die telling',
  reportWhy: 'Wat is daarmee verkeerd? Opsioneel.',
  reportSend: 'Stuur rapport',
  reportSent: 'Dankie. Iemand sal daarna kyk.',
  reportSignIn: 'Meld aan om iets te rapporteer.',
  reportGone: 'Dit is nie meer daar nie.',
  reportCancel: 'Kanselleer',

  deleteAccount: 'Skrap my rekening',
  deleteAccountWhat:
    'Dit verwyder jou profiel en elke spel wat jy gehou het, vir altyd. Dit kan nie ongedaan gemaak word nie.',
  deleteAccountAsk: 'Stuur my ’n kode',
  deleteConfirm: 'Skrap dit vir altyd',
  deleteGone: 'Jou rekening is weg. Dankie dat jy gespeel het.',
  deleteNoAddress:
    'Daar is geen bevestigde adres op hierdie rekening nie, dus kan ’n skrapping nie nagegaan word nie. Kontak ons en ons doen dit met die hand.',

  rulesetFacts: 'Woorde van {letters} · elke {seconds} ’n nuwe blokkie',
  plurals: {
    words: { one: '{n} woord', other: '{n} woorde' },
    rounds: { one: '{n} rondte', other: '{n} rondtes' },
    flips: { one: '{n} skuif', other: '{n} skuiwe' },
    ticks: { one: '{n} tik', other: '{n} tikke' },
    points: { one: '{n} punt', other: '{n} punte' },
    minLetters: { one: 'minstens {n} letter', other: 'minstens {n} letters' },
    seconds: { one: '{n} sekonde', other: '{n} sekondes' },
  },
}
